export default __webpack_public_path__ + "static/Lense_4.3mm_-_Angle_of_View-ea537615af8bb7857b9909c47d0d8740.webp";